import * as Vue from 'vue';
import * as Router from 'vue-router';
import Home from './home/';
import Hello from './Hello';
Vue.use(Router);
var config = {
    linkActiveClass: 'active',
    scrollBehavior: function () { return ({ x: 0, y: 0 }); },
    routes: [
        { path: '/home', component: Home },
        { path: '/hello', component: Hello },
        { path: '*', redirect: '/home' }
    ]
};
var app = require('./App.vue');
app.router = new Router(config);
new Vue(app).$mount('#app');



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 8
// module chunks = 0